module.exports = __webpack_public_path__ + "img/img-fachai-fish-s.9f616249.png";